<div class="request-files-container">
  <div class="title-area">
    <div class="title">{{ title() }}</div>
    <div class="spacer"></div>
  </div>

  <div class="files-container">
    <div class="user-info" [formGroup]="userForm()">
      <div class="user-name">
        @let userNameForm = userForm().get('userName');
        <label for="user_name">Name</label>
        <input
          formControlName="userName"
          id="user_name"
          type="text"
          class="form-input"
          [ngClass]="{ 'form-input--invalid': userNameForm.touched && userNameForm.invalid }"
        />
        @if (userNameForm.touched && userNameForm.invalid && userNameForm.errors.required) {
          <mat-error>Name is required</mat-error>
        }
      </div>
      <div class="user-email">
        @let userEmailForm = userForm().get('userEmail');
        <label for="user_email">Email</label>
        <input
          formControlName="userEmail"
          id="user_email"
          type="email"
          class="form-input"
          [ngClass]="{ 'form-input--invalid': userEmailForm.touched && userEmailForm.invalid }"
        />
        @if (userEmailForm.touched && userEmailForm.invalid) {
          @if (userEmailForm.errors.required) {
            <mat-error>Email is required</mat-error>
          } @else if (userEmailForm.errors.email) {
            <mat-error>Value should be a valid email</mat-error>
          }
        }
      </div>
    </div>

    <div class="file-drop-zone">
      <awn-upload-files type="drag-button-big" [entityData]="uploadJobRequestData()" [defaultState]="UploadFileStatus.HOLD" />
    </div>

    @if (stagedUploadJobIds().length) {
      <div class="staged-files">
        <div class="staged-files-title">Selected Files</div>
        <div class="file-jobs">
          @for (jobId of stagedUploadJobIds(); track jobId) {
            <awn-file-upload-job-item [jobId]="jobId" />
          }
        </div>
        <div class="staged-footer">
          <div class="footer-items-totals">
            <span class="footer-items-count">{{ filesToSubmitCount() }} Items</span>
            <span class="footer-items-size">{{ stagedFilesBytesSize() | fileSize }}</span>
          </div>
          <span class="footer-clear-all" (click)="clearAllFiles.emit()">Clear All</span>
        </div>
      </div>
    }

    <div class="submit-button-area">
      <button andButton color="primary" size="large" class="primary" [disabled]="disableSubmit()" (click)="submitFiles.emit()">
        Submit {{ filesToSubmitCount() ? filesToSubmitCount() : '' }} Files
      </button>
    </div>
  </div>

  <div class="footer-area">
    <span>Your files will be securely uploaded to {{ firmName() }}.</span>
  </div>
</div>
